// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"2458564f","376":"9d36dc0c","453":"f5117e8e"}[chunkId] + ".chunk.js";
};